import styled from "styled-components";

export interface GenericSvgIconWrapperProps {
  $width?: string;
  $height?: string;
  $color?: string;
  $bgColor?: string;
}

const GenericSvgIconWrapper = styled.span<GenericSvgIconWrapperProps>`
  display: block;
  ${({ $color }) => $color && `color: ${$color};`};
  & > svg {
    display: block;
    width: ${({ $width }) => $width || "1.125rem"};
    height: ${({ $height }) => $height || "1.125rem"};
    ${({ $color }) => $color && `fill: ${$color};`};

    & > rect {
      ${({ $bgColor }) => $bgColor && `fill: ${$bgColor};`};
    }
  }
`;

export default GenericSvgIconWrapper;
